import React from 'react';
import {
	CargoContractStatus,
	CargoContractStatusTypes,
} from '@shared/utils/constants';
import { Port } from '@api/utils/ports';
import TentativeBookingsMarker from './TentativeBookingsMarker';
import ContractedCargosMarker from './ContractedCargosMarker';

type CargoLayerConfig = {
	status: CargoContractStatus;
	renderMarker: (
		port: Port,
		onClick: (p: Port) => void,
		isSelected: boolean,
	) => React.ReactNode;
};

const cargoLayerConfig: CargoLayerConfig[] = [
	{
		status: CargoContractStatusTypes.TentativeBooking,
		renderMarker: (port, onClick, isSelected) => (
			<TentativeBookingsMarker
				key={`tentative-${port.id}`}
				loadingPort={port}
				onLoadingPortClick={onClick}
				isSelected={isSelected}
			/>
		),
	},
	{
		status: CargoContractStatusTypes.Contracted,
		renderMarker: (port, onClick, isSelected) => (
			<ContractedCargosMarker
				key={`contracted-${port.id}`}
				loadingPort={port}
				onLoadingPortClick={onClick}
				isSelected={isSelected}
			/>
		),
	},
];

export default cargoLayerConfig;